import React from 'react';

import MuiAlert, { AlertProps, AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {
  useGetToastNotificationState,
  useSetToastNotificationState,
} from 'redux/toastNotification/toastNotificationSlice';

const Alert = React.forwardRef((props: AlertProps, ref?: React.Ref<any>) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

function ToastNotification() {
  const { isOpen, message, notificationType } = useGetToastNotificationState();
  const { closeNotification } = useSetToastNotificationState();
  return (
    <>
      {isOpen ? (
        <Snackbar
          open={!!isOpen}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={3000}
          onClose={closeNotification}
        >
          <Alert
            onClose={closeNotification}
            severity={notificationType as AlertColor}
            sx={{ width: '100%', color: 'white' }}
          >
            {message}
          </Alert>
        </Snackbar>
      ) : null}
    </>
  );
}

export default ToastNotification;
